<!-- ================首页-名师教研（协同备课/听课评课/个人备课/已发布备课）====================-->
<template>
    <div class="tea-research-page">
        <home-head />
        <div class="tea-research-body">
            <div class="tea-research-inner">
                <!-- 标题区 -->
                <div class="tea-research-header">
                    <div class="tea-research-title-box">
                        <div class="tea-research-title">名师教研</div>
                        <div class="tea-research-subtitle">专业指导 美育赋能</div>
                    </div>
                    <div class="tea-research-actions">
                        <div class="back-btn" @click="goHome">
                            <span>返回首页</span>
                        </div>
                    </div>
                </div>

                <!-- 标签切换 -->
                <div class="tea-research-tabs">
                    <div class="tab-item" :class="{ active: activeTab === 'team' }" @click="changeTab('team')">协同备课</div>
                    <div class="tab-item" :class="{ active: activeTab === 'evaluation' }" @click="changeTab('evaluation')">听课评课</div>
                    <div class="tab-item" :class="{ active: activeTab === 'self' }" @click="changeTab('self')">个人备课</div>
                    <div class="tab-item" :class="{ active: activeTab === 'published' }" @click="changeTab('published')">已发布备课</div>
                </div>

                <!-- 筛选区 -->
                <div class="tea-research-filter" v-loading="loading">
                    <div class="filter-left">
                        <div class="filter-item">
                            <span class="filter-label">学段</span>
                            <el-select class="filter-select" v-model="currentQuery.periodKey" clearable placeholder="请选择" @change="changePeriod">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <span class="filter-label">年级</span>
                            <el-select class="filter-select" v-model="currentQuery.gradeKey" clearable placeholder="请选择" @change="changeGrade">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <span class="filter-label">学科</span>
                            <el-select class="filter-select" v-model="currentQuery.subjectKey" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                        <div class="filter-item" v-if="activeTab === 'team' || activeTab === 'evaluation'">
                            <span class="filter-label">{{ activeTab === 'evaluation' ? '状态' : '状态' }}</span>
                            <el-select class="filter-select" v-model="currentQuery.status" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in currentStatusList" :key="item.value" :label="item.name" :value="item.value" />
                            </el-select>
                        </div>
                        <div class="filter-item" v-if="activeTab === 'team'">
                            <span class="filter-label">参与</span>
                            <el-select class="filter-select" v-model="currentQuery.joinStatus" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in joinStatusList" :key="item.value" :label="item.name" :value="item.value" />
                            </el-select>
                        </div>
                        <div class="filter-item" v-if="activeTab === 'evaluation'">
                            <span class="filter-label">类型</span>
                            <el-select class="filter-select" v-model="currentQuery.type" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in evaTypeList" :key="item.value" :label="item.name" :value="item.value" />
                            </el-select>
                        </div>
                    </div>
                    <div class="filter-right">
                        <input class="search-input" type="text" :placeholder="searchPlaceholder" v-model="currentQuery.title" @keyup.enter="handleSearch" />
                        <div class="search-btn" @click="handleSearch">搜索</div>
                    </div>
                </div>

                <!-- 列表区 -->
                <div class="tea-research-list" v-loading="loading">
                    <!-- 备课卡片 -->
                    <template v-if="activeTab !== 'evaluation'">
                        <div class="lesson-card" v-for="item in currentList" :key="item.lessonId" @click="goLessonDetail(item)">
                            <div class="card-title" :title="item.title">{{ item.title }}</div>
                            <div class="card-time" v-if="activeTab !== 'self'">备课时段：{{ formatLessonTime(item) }}</div>
                            <div class="card-cover">
                                <img class="img-100" :src="item.coverUrl || defaultCover" :alt="item.title" />
                                <div class="card-status" :class="lessonStatusClass(item.status)">{{ activeTab === 'published' ? '已发布' : lessonStatusLabel(item.status) }}</div>
                            </div>
                            <div class="card-info">
                                <div class="card-info-item">
                                    <span class="info-label">学段年级学科：</span>
                                    <span class="info-value">{{ formatPgs(item) }}</span>
                                </div>
                                <div class="card-info-item" v-if="activeTab !== 'self'">
                                    <span class="info-label">主备人：</span>
                                    <span class="info-value">{{ item.leadUserName || '--' }}</span>
                                </div>
                                <div class="card-info-item">
                                    <span class="info-label">课题级别：</span>
                                    <span class="info-value">{{ item.lessonLevelName || '--' }}</span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- 听评课卡片 -->
                    <template v-else>
                        <div class="lesson-card eva-card" v-for="item in currentList" :key="item.lessonId" @click="goEvaDetail(item)">
                            <div class="card-title" :title="item.title">{{ item.title }}</div>
                            <div class="card-time">任务时段：{{ formatEvaTime(item) }}</div>
                            <div class="card-cover">
                                <img class="img-100" :src="item.coverUrl || defaultCover" :alt="item.title" />
                                <div class="card-status" :class="evaStatusClass(item.status)">{{ evaStatusLabel(item.status) }}</div>
                            </div>
                            <div class="card-info">
                                <div class="card-info-item">
                                    <span class="info-label">学段年级学科：</span>
                                    <span class="info-value">{{ formatPgs(item) }}</span>
                                </div>
                                <div class="card-info-item">
                                    <span class="info-label">授课老师：</span>
                                    <span class="info-value">{{ item.lectureTeacherName || '--' }}</span>
                                </div>
                                <div class="card-info-item">
                                    <span class="info-label">类型：</span>
                                    <span class="info-value">{{ evaTypeLabel(item.type) }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- 暂无数据 -->
                <div class="empty-state" v-if="!loading && currentList.length === 0">
                    <div class="empty-icon">
                        <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                    </div>
                    <div class="empty-text">暂无数据</div>
                </div>

                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="currentTotal > 0">
                    <pagination :background="false"
                                :pageSizes="[12, 24, 36]"
                                :total="currentTotal"
                                v-model:page="currentQuery.pageNum"
                                v-model:limit="currentQuery.pageSize"
                                @pagination="pageList" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { lessonPageLessons } from "@/api/admin/lesson";
import { evaluationPageLessons } from "@/api/admin/evaluation";
import { queryDict } from "@/api/admin/dict";
import { timestampToTime } from "@/utils/date";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "teaResearch",
    data() {
        return {
            loading: false,
            activeTab: "team",
            defaultCover: require("@/assets/logo/logo.png"),
            periodList: [],
            gradeList: [],
            subjectList: [],
            lessonStatusList: [
                { name: "进行中", value: 2 },
                { name: "已完成", value: 9 },
            ],
            evaStatusList: [
                { name: "进行中", value: 2 },
                { name: "已结束", value: 3 },
            ],
            joinStatusList: [
                { name: "已参与", value: 1 },
                { name: "未参与", value: 0 },
            ],
            evaTypeList: [
                { name: "推门", value: 0 },
                { name: "线上", value: 1 },
                { name: "录播视频", value: 2 },
            ],
            // 各标签页独立数据
            tabData: {
                team: {
                    list: [],
                    total: 0,
                    query: {
                        title: "",
                        periodKey: "",
                        gradeKey: "",
                        subjectKey: "",
                        status: "",
                        joinStatus: "",
                        type: 0,
                        releaseStatus: "",
                        pageNum: 1,
                        pageSize: 12,
                    },
                },
                self: {
                    list: [],
                    total: 0,
                    query: {
                        title: "",
                        periodKey: "",
                        gradeKey: "",
                        subjectKey: "",
                        status: "",
                        joinStatus: "",
                        type: 1,
                        releaseStatus: "",
                        pageNum: 1,
                        pageSize: 12,
                    },
                },
                published: {
                    list: [],
                    total: 0,
                    query: {
                        title: "",
                        periodKey: "",
                        gradeKey: "",
                        subjectKey: "",
                        status: "",
                        joinStatus: "",
                        type: 0,
                        releaseStatus: "2",
                        pageNum: 1,
                        pageSize: 12,
                    },
                },
                evaluation: {
                    list: [],
                    total: 0,
                    query: {
                        title: "",
                        periodKey: "",
                        gradeKey: "",
                        subjectKey: "",
                        status: "",
                        type: "",
                        pageNum: 1,
                        pageSize: 12,
                    },
                },
            },
        };
    },
    computed: {
        currentQuery() {
            return this.tabData[this.activeTab].query;
        },
        currentList() {
            return this.tabData[this.activeTab].list;
        },
        currentTotal() {
            return this.tabData[this.activeTab].total;
        },
        currentStatusList() {
            return this.activeTab === "evaluation" ? this.evaStatusList : this.lessonStatusList;
        },
        searchPlaceholder() {
            return this.activeTab === "evaluation" ? "请输入听评课名称" : "请输入备课名称";
        },
    },
    watch: {
        "$route.query": {
            handler(newQuery) {
                if (!newQuery || this.isQuerySameAsCurrent(newQuery)) return;
                this.restoreFromQuery(newQuery);
            },
        },
    },
    created() {
        this.restoreFromQuery();
    },
    mounted() {},
    methods: {
        /* ===============字典查询===================== */
        loadDict() {
            this.periodList = [];
            this.gradeList = [];
            this.subjectList = [];
            queryDict({ code: "lession_xd_nj_xk" }).then(res => {
                if (res.data && res.data.code === 1) {
                    this.periodList = res.data.data || [];
                    this.restoreCascader();
                }
            });
        },

        /* ===============级联恢复===================== */
        restoreCascader() {
            const q = this.currentQuery;
            this.gradeList = [];
            this.subjectList = [];
            if (!q.periodKey) return;
            const period = this.periodList.find(p => p.dictKey === q.periodKey);
            if (!period) return;
            this.gradeList = period.childrenList || [];
            if (!q.gradeKey) return;
            const grade = this.gradeList.find(g => g.dictKey === q.gradeKey);
            if (!grade) return;
            this.subjectList = grade.childrenList || [];
        },

        /* ===============切换标签===================== */
        changeTab(tab) {
            if (this.activeTab === tab) return;
            this.activeTab = tab;
            // 个人备课与已发布备课不展示备课状态、是否参与，切回时清空避免隐藏条件影响查询
            if (tab === "self" || tab === "published") {
                this.currentQuery.status = "";
                this.currentQuery.joinStatus = "";
            }
            this.restoreCascader();
            if (this.currentList.length === 0) {
                this.pageList();
            }
            this.syncQueryToUrl();
        },

        /* ===============将当前查询条件同步到 URL===================== */
        syncQueryToUrl() {
            const query = { ...this.$route.query };
            query.tab = this.activeTab;
            const setQuery = (key, value) => {
                if (value !== undefined && value !== null && value !== "") {
                    query[key] = value;
                } else {
                    delete query[key];
                }
            };
            const q = this.currentQuery;
            setQuery("periodKey", q.periodKey);
            setQuery("gradeKey", q.gradeKey);
            setQuery("subjectKey", q.subjectKey);
            setQuery("status", q.status);
            setQuery("title", q.title);
            if (this.activeTab === "evaluation") {
                setQuery("type", q.type);
                delete query.joinStatus;
            } else {
                setQuery("joinStatus", q.joinStatus);
                delete query.type;
            }
            query.pageNum = q.pageNum;
            query.pageSize = q.pageSize;
            this.$router.replace({ query }).catch(() => {});
        },

        /* ===============判断 URL 查询是否与当前状态一致===================== */
        isQuerySameAsCurrent(query) {
            const q = query || {};
            if ((q.tab || "team") !== this.activeTab) return false;
            const fields = ["periodKey", "gradeKey", "subjectKey", "status", "title"];
            for (const f of fields) {
                const qv = q[f] === undefined || q[f] === null || q[f] === "" ? undefined : String(q[f]);
                const pv = this.currentQuery[f] === undefined || this.currentQuery[f] === null || this.currentQuery[f] === "" ? undefined : String(this.currentQuery[f]);
                if (qv !== pv) return false;
            }
            if (this.activeTab === "evaluation") {
                const qType = q.type === undefined || q.type === null || q.type === "" ? undefined : String(q.type);
                const pType = this.currentQuery.type === undefined || this.currentQuery.type === null || this.currentQuery.type === "" ? undefined : String(this.currentQuery.type);
                if (qType !== pType) return false;
            } else {
                const qJoin = q.joinStatus === undefined || q.joinStatus === null || q.joinStatus === "" ? undefined : String(q.joinStatus);
                const pJoin = this.currentQuery.joinStatus === undefined || this.currentQuery.joinStatus === null || this.currentQuery.joinStatus === "" ? undefined : String(this.currentQuery.joinStatus);
                if (qJoin !== pJoin) return false;
            }
            const pageNum = Number(q.pageNum) || 1;
            const pageSize = Number(q.pageSize) || 12;
            return pageNum === Number(this.currentQuery.pageNum) && pageSize === Number(this.currentQuery.pageSize);
        },

        /* ===============从 URL 查询中恢复查询条件===================== */
        restoreFromQuery(query = this.$route.query) {
            const q = query || {};
            const tab = q.tab;
            if (tab && ["team", "self", "published", "evaluation"].includes(tab)) {
                this.activeTab = tab;
            }
            const current = this.currentQuery;
            ["periodKey", "gradeKey", "subjectKey", "status", "title"].forEach(key => {
                if (q[key] !== undefined && q[key] !== null) {
                    current[key] = q[key];
                }
            });
            if (this.activeTab === "evaluation") {
                if (q.type !== undefined && q.type !== null) {
                    current.type = q.type;
                }
            } else {
                if (q.joinStatus !== undefined && q.joinStatus !== null) {
                    current.joinStatus = q.joinStatus;
                }
            }
            current.pageNum = Number(q.pageNum) || 1;
            current.pageSize = Number(q.pageSize) || 12;
            this.loadDict();
            this.pageList();
        },

        /* ===============级联选择===================== */
        changePeriod() {
            const q = this.currentQuery;
            q.gradeKey = "";
            q.subjectKey = "";
            this.gradeList = [];
            this.subjectList = [];
            if (q.periodKey) {
                const period = this.periodList.find(p => p.dictKey === q.periodKey);
                this.gradeList = period ? period.childrenList || [] : [];
            }
            q.pageNum = 1;
            this.pageList();
        },
        changeGrade() {
            const q = this.currentQuery;
            q.subjectKey = "";
            this.subjectList = [];
            if (q.periodKey && q.gradeKey) {
                const period = this.periodList.find(p => p.dictKey === q.periodKey);
                const gradeList = period ? period.childrenList || [] : [];
                const grade = gradeList.find(g => g.dictKey === q.gradeKey);
                this.subjectList = grade ? grade.childrenList || [] : [];
            }
            q.pageNum = 1;
            this.pageList();
        },

        /* ===============筛选与搜索===================== */
        handleFilterChange() {
            this.currentQuery.pageNum = 1;
            this.pageList();
        },
        handleSearch() {
            this.currentQuery.pageNum = 1;
            this.pageList();
        },

        /* ===============分页查询===================== */
        pageList(e) {
            this.loading = true;
            this.tabData[this.activeTab].list = [];
            if (e) {
                this.currentQuery.pageNum = e.page;
                this.currentQuery.pageSize = e.limit;
            }
            this.syncQueryToUrl();
            if (this.activeTab === "evaluation") {
                this.loadEvaluationList();
            } else {
                this.loadLessonList();
            }
        },

        loadLessonList() {
            const params = { ...this.currentQuery };
            lessonPageLessons(params).then(res => {
                if (res.data && res.data.code === 1) {
                    // 过滤初始状态（status=1）的备课
                    const list = (res.data.data.list || []).filter(e => e.status !== 1);
                    this.tabData[this.activeTab].total = Math.max((res.data.data.total || 0) - ((res.data.data.list || []).length - list.length), 0);
                    this.tabData[this.activeTab].list = list;
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        loadEvaluationList() {
            const params = { ...this.currentQuery };
            evaluationPageLessons(params).then(res => {
                if (res.data && res.data.code === 1) {
                    // 过滤初始状态（status=1）的听评课
                    const list = (res.data.data.list || []).filter(e => e.status !== 1);
                    this.tabData[this.activeTab].total = Math.max((res.data.data.total || 0) - ((res.data.data.list || []).length - list.length), 0);
                    this.tabData[this.activeTab].list = list;
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        /* ===============工具方法===================== */
        formatPgs(item) {
            const period = item.periodName || "--";
            const grade = item.gradeName || "--";
            const subject = item.subjectName || "--";
            return `${period}-${grade}-${subject}`;
        },
        formatLessonTime(item) {
            const begin = item.beginTime ? timestampToTime(item.beginTime) : "";
            const end = item.endTime ? timestampToTime(item.endTime) : "";
            if (begin && end) return begin + "至" + end;
            return begin || end || "--";
        },
        formatEvaTime(item) {
            const begin = item.beginTime ? timestampToTime(item.beginTime) : "";
            const end = item.endTime ? timestampToTime(item.endTime) : "";
            if (begin && end) return begin + "至" + end;
            return begin || end || "--";
        },
        lessonStatusLabel(status) {
            const map = {
                1: "初始",
                2: "进行中",
                3: "修正中",
                4: "协同中",
                5: "共案待传",
                8: "待发布",
                9: "备课完成",
            };
            return map[status] || "初始";
        },
        lessonStatusClass(status) {
            if (status === 9) return "status-end";
            if (status === 2 || status === 4) return "status-active";
            return "status-default";
        },
        evaStatusLabel(status) {
            const map = {
                0: "未提请",
                1: "初始",
                2: "进行中",
                3: "已结束",
            };
            return map[status] || "初始";
        },
        evaStatusClass(status) {
            if (status === 3) return "status-end";
            if (status === 2) return "status-active";
            return "status-default";
        },
        evaTypeLabel(type) {
            const map = {
                0: "推门",
                1: "线上",
                2: "录播视频",
            };
            return map[type] || "推门";
        },

        /* ===============跳转===================== */
        goHome() {
            this.$router.push("/museum/home");
        },
        goLessonDetail(item) {
            if (this.activeTab === "self") {
                this.$router.push({
                    path: "/tea/teaSelfLessonInfo",
                    query: { lessonId: item.lessonId },
                });
            } else if (this.activeTab === "team") {
                this.$router.push({
                    path: "/tea/teaTeamLessonInfo",
                    query: { lessonId: item.lessonId },
                });
            } else if (this.activeTab === "published") {
                this.$router.push({
                    path: "/tea/teaReleaseLessonInfo",
                    query: { lessonId: item.lessonId },
                });
            }
        },
        goEvaDetail(item) {
            this.$router.push({
                path: "/tea/teaEvaLessonInfo",
                query: { lessonId: item.lessonId },
            });
        },
    },
};
</script>

<style scoped>
.tea-research-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.tea-research-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0 80px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.tea-research-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px 50px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
}

/* 标题区 */
.tea-research-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.tea-research-title-box {
    display: flex;
    flex-direction: column;
}

.tea-research-title {
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 6px;
}

.tea-research-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.tea-research-actions {
    display: flex;
    align-items: center;
}

.back-btn {
    height: 36px;
    line-height: 36px;
    padding: 0 32px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

/* 标签切换 */
.tea-research-tabs {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.tab-item {
    min-width: 110px;
    height: 36px;
    line-height: 34px;
    padding: 0 20px;
    text-align: center;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.tab-item:hover {
    background-color: #fff5f5;
}

.tab-item.active {
    background-color: #b22222;
    color: #ffffff;
    border-color: #b22222;
}

/* 筛选区 */
.tea-research-filter {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.filter-left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.filter-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-label {
    font-size: 15px;
    color: #4b5563;
    font-family: sans-serif;
    white-space: nowrap;
}

.filter-select {
    width: 140px !important;
}

.filter-select .el-select__wrapper {
    min-height: 36px !important;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
}

.filter-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.search-input {
    width: 240px;
    height: 34px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.search-input:focus {
    border-color: #b22222;
}

.search-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 22px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.search-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

/* 列表区 */
.tea-research-list {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 60px;
    padding-top: 10px;
    align-content: flex-start;
}

.tea-research-list::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.tea-research-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.tea-research-list::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.tea-research-list::-webkit-scrollbar-thumb:hover {
    background: #9a9a9a;
}

.lesson-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 14px;
    cursor: pointer;
    transition: all 0.25s ease;
}

.lesson-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.card-title {
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.5;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.card-time {
    width: 100%;
    font-size: 13px;
    color: #4b5563;
    font-family: sans-serif;
    margin-bottom: 10px;
}

.card-cover {
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 12px;
    background-color: #f3f4f6;
    border-radius: 4px;
    position: relative;
}

.card-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.card-status {
    position: absolute;
    right: 10px;
    bottom: 10px;
    min-width: 70px;
    height: 26px;
    line-height: 26px;
    padding: 0 12px;
    border-radius: 13px;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    font-family: sans-serif;
}

.status-default {
    background-color: #4095e5;
}

.status-active {
    background-color: #ffbf6b;
}

.status-end {
    background-color: #81b337;
}

.card-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.card-info-item {
    width: 100%;
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.info-label {
    color: #4b5563;
}

.info-value {
    color: #1f2937;
}

/* 暂无数据 */
.empty-state {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 100px;
    box-sizing: border-box;
}

.empty-icon {
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
}

.empty-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

/* 分页 */
.pagination-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -60px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
}

.pagination-wrapper .el-pagination__total {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pagination__jump {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pager li {
    font-size: 13px;
    color: #4b5563;
}

.pagination-wrapper .el-pager li.active {
    background-color: #b22222;
    color: #ffffff;
}

.pagination-wrapper .el-select .el-input__wrapper {
    height: 28px;
    min-height: 28px;
    font-size: 13px;
}

@media (max-width: 1280px) {
    .tea-research-inner { padding: 0 20px; }
    .tea-research-title { font-size: 22px; }
    .tea-research-list { gap: 16px; }
    .filter-left { gap: 14px; }
    .filter-select { width: 120px !important; }
    .search-input { width: 200px; }
}

@media (max-width: 1024px) {
    .tea-research-title { font-size: 20px; }
    .tea-research-subtitle { font-size: 13px; }
    .tea-research-filter { flex-wrap: wrap; gap: 12px; }
    .filter-left { gap: 12px; }
    .filter-select { width: 100px !important; }
    .search-input { width: 160px; }
    .tea-research-list { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
}

@media (max-width: 768px) {
    .tea-research-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .tea-research-tabs { flex-wrap: wrap; }
    .tea-research-filter { flex-direction: column; align-items: flex-start; }
    .filter-left { flex-wrap: wrap; }
    .filter-right { width: 100%; }
    .search-input { flex: 1; }
    .tea-research-list { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
    .lesson-card { padding: 10px; }
    .card-info-item { font-size: 12px; }
}
</style>
